module.exports = __webpack_public_path__ + "img/SKWINKELNetActieEvaluaties5FA7C4.c636ad9c.png";